import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_215xw4p1o0: FaireBrandEntity = {
  token: "b_215xw4p1o0",
  type: "brand",
  name: "Universal Yums",
  avatarUrl:
    "https://cdn.faire.com/fastly/10e21047f2ad9b4e97b894c9fa35bcdefa95419e7652ade52041ba6e5090606d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5528166f3af5fea4e36f0ad7dad791a95152f4d81852faffd85b0a02be133c27.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/10e21047f2ad9b4e97b894c9fa35bcdefa95419e7652ade52041ba6e5090606d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5528166f3af5fea4e36f0ad7dad791a95152f4d81852faffd85b0a02be133c27.jpeg",
  location: "Roseland, NJ, USA",
  minimumOrderDollars: 137,
  rating: 4.4,
  reviewCount: 18,
  isInsider: true,
  description:
    "Since 2014, Universal Yums has brought the flavors of the world to over 1,000,000 households in the USA. Our first-ever retail collection includes five country-themed boxes, each filled with the featured country's finest sweets and savory snacks. Each box comes with a guidebook packed with cultural education, trivia, recipes, and tasting games, providing hours of fun for families, couples, or friends. The retail collection also features the world's first-ever \"Around the World\" Candy Advent Calendar, filled with 24 different types of candy from around the globe.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:35.100Z",
    importedBy: "entity-db-cli",
  },
};
